"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.siteSearchReducer = exports.siteSearchActions = exports.TYPES = exports.INIT_STATE = exports.CONTENTS = void 0;
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const SEARCH = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'SiteSearch';

/**
 * アクションタイプ
 */
const TYPES = exports.TYPES = {
  SET_CONTENT: SEARCH + 'SetContent',
  SET_CONDITION: SEARCH + 'SetCondition',
  SET_CONDITIONS: SEARCH + 'SetConditions',
  SET_DETAIL: SEARCH + 'SetDetail',
  SET_ENTRY: SEARCH + 'SetEntry',
  SET_ENTRIES: SEARCH + 'SetEntries',
  SET_MODIFIED: SEARCH + 'SetModified',
  CHANGE_SEARCH_CONDITION: SEARCH + 'ChangeSearchCondition',
  SET_SEARCH_RESULT: SEARCH + 'SetSearchResult',
  GO_MAIN: SEARCH + 'GoMain',
  GO_UPDATE: SEARCH + 'GoUpdate',
  GO_DELETE: SEARCH + 'GoDelete',
  GO_DETAIL: SEARCH + 'GoDetail',
  GO_UPDATE_FROM_DETAIL: SEARCH + 'GoUpdateFromDetail',
  GO_DELETE_FROM_DETAIL: SEARCH + 'GoDeleteFromDetail',
  BACK_DETAIL: SEARCH + 'BackDetail',
  CHANGE_VIEW_NUM: SEARCH + 'ChangeViewNum',
  CHANGE_SCROLL_TOP: SEARCH + 'ChangeScrollTop',
  RESET_PAGING: SEARCH + 'ResetPaging',
  CHANGE_PAGE: SEARCH + 'ChangePage',
  CLEAR: SEARCH + 'Clear',
  SET_SITE_CONNECT_KBN: SEARCH + 'SetSiteLinkCheckKbn'
};

/**
 * コンテンツタイプ
 */
const CONTENTS = exports.CONTENTS = {
  MAIN: 'main',
  UPDATE: 'update',
  DETAIL: 'detail',
  DELETE: 'delete'
};
const INIT_CONDITION = Object.freeze({
  kaishaCd: '',
  soshikiCd: '',
  label: '',
  siteNm: '',
  areaCd: '',
  tdfkCd: ''
});

/**
 * 初期State
 */
const INIT_STATE = exports.INIT_STATE = {
  dispContent: CONTENTS.MAIN,
  searchConditions: _objectSpread({}, INIT_CONDITION),
  fixedConditions: _objectSpread({}, INIT_CONDITION),
  searchResult: [],
  selectSiteNo: '',
  checkSiteLinkKbn: 0,
  scrollTop: {
    index: 0,
    scrollY: 0,
    noSticky: false
  },
  paging: {
    viewNum: 50,
    currentPage: 0
  },
  detail: {
    buildingNo: 0,
    buildingNm: '',
    siteNo: 0,
    siteNm: '',
    tdfkCd: '',
    address: '',
    siteFunc: [],
    kaishaCd: '',
    kaishaNm: '',
    soshikiCd: [],
    soshikiNm: [],
    siteTypeCd: '1',
    areaCd: '',
    areaNm: '',
    workersCnt: '',
    floors: '',
    totalStories: '',
    communicationMeans: [],
    communicationOther: '',
    storedFood: '',
    storedFoodNote: '',
    storedDrink: '',
    storedDrinkNote: '',
    warehouseArticleNote: '',
    warehouseInTankNote: '',
    lastUpdNm: '',
    lastUpdDt: '',
    updId: '',
    updDt: ''
  },
  fromDetail: false,
  search: false,
  modified: false
};

/**
 * アクション定義
 */
const siteSearchActions = exports.siteSearchActions = (0, _reduxActions.createActions)({
  [TYPES.SET_CONDITION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_CONDITIONS]: function () {
    return {
      data: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_CONTENT]: function () {
    return {
      content: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SEARCH_CONDITION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_SEARCH_RESULT]: function () {
    return {
      results: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_DETAIL]: function () {
    return {
      data: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_ENTRY]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_ENTRIES]: function () {
    return {
      data: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_MODIFIED]: function () {
    return {
      modified: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_DETAIL]: function () {
    return {
      selectSiteNo: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_UPDATE]: function () {
    return {
      selectSiteNo: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_DELETE]: function () {
    return {
      selectSiteNo: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SCROLL_TOP]: function () {
    return {
      scrollTop: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_PAGE]: function () {
    return {
      currentPage: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_MAIN]: function () {
    return {
      search: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_VIEW_NUM]: function () {
    return {
      viewNum: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_SITE_CONNECT_KBN]: function () {
    return {
      checkSiteLinkKbn: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
}, TYPES.GO_UPDATE_FROM_DETAIL, TYPES.GO_DELETE_FROM_DETAIL, TYPES.BACK_DETAIL, TYPES.RESET_PAGING, TYPES.CLEAR);

/**
 * Reducer定義
 */
const siteSearchReducer = exports.siteSearchReducer = (0, _reduxActions.handleActions)({
  [TYPES.SET_CONDITION]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
        [action.payload.key]: action.payload.value
      })
    });
  },
  [TYPES.SET_CONDITIONS]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      searchConditions: action.payload.data
    });
  },
  [TYPES.SET_CONTENT]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: action.payload.content
    });
  },
  [TYPES.CHANGE_SEARCH_CONDITION]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
        [action.payload.key]: action.payload.value
      })
    });
  },
  [TYPES.SET_SEARCH_RESULT]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchResult: action.payload.results,
    fixedConditions: _objectSpread({}, state.searchConditions),
    search: false,
    modified: false
  }),
  [TYPES.SET_DETAIL]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      detail: action.payload.data
    });
  },
  [TYPES.SET_ENTRY]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        [action.payload.key]: action.payload.value
      })
    });
  },
  [TYPES.SET_ENTRIES]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: action.payload.data
    });
  },
  [TYPES.SET_MODIFIED]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      modified: action.payload.modified
    });
  },
  [TYPES.GO_DETAIL]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    selectSiteNo: action.payload.selectSiteNo,
    dispContent: CONTENTS.DETAIL
  }),
  [TYPES.GO_UPDATE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    selectSiteNo: action.payload.selectSiteNo,
    dispContent: CONTENTS.UPDATE
  }),
  [TYPES.GO_DELETE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    selectSiteNo: action.payload.selectSiteNo,
    dispContent: CONTENTS.DELETE
  }),
  [TYPES.GO_UPDATE_FROM_DETAIL]: state => {
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: CONTENTS.UPDATE,
      fromDetail: true
    });
  },
  [TYPES.GO_DELETE_FROM_DETAIL]: state => {
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: CONTENTS.DELETE,
      fromDetail: true
    });
  },
  [TYPES.BACK_DETAIL]: state => {
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: CONTENTS.DETAIL,
      fromDetail: false
    });
  },
  [TYPES.GO_MAIN]: (state, action) => {
    let searchConditions;
    if (action.payload.search) {
      searchConditions = state.fixedConditions;
    } else {
      searchConditions = state.searchConditions;
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: CONTENTS.MAIN,
      search: action.payload.search,
      searchConditions
    });
  },
  [TYPES.CHANGE_VIEW_NUM]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      viewNum: action.payload.viewNum
    })
  }),
  [TYPES.CHANGE_SCROLL_TOP]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    scrollTop: action.payload.scrollTop
  }),
  [TYPES.CLEAR]: () => {
    return _objectSpread({}, INIT_STATE);
  },
  [TYPES.CHANGE_PAGE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      currentPage: action.payload.currentPage
    })
  }),
  [TYPES.RESET_PAGING]: state => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread({}, INIT_STATE.paging)
  }),
  [TYPES.SET_SITE_CONNECT_KBN]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    checkSiteLinkKbn: action.payload.checkSiteLinkKbn
  })
}, INIT_STATE);